import script from "./rBarMonitored.vue?vue&type=script&setup=true&lang=ts"
export * from "./rBarMonitored.vue?vue&type=script&setup=true&lang=ts"

import "./rBarMonitored.vue?vue&type=style&index=0&id=37622622&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37622622"]])

export default __exports__